import React, { useContext } from 'react'

import BoxSlotList from './BoxSlotList/BoxSlotList'
import ErrorPage from '../ErrorPage/ErrorPage'
import PublicContext from '../PublicContext'

export default function BoxPage () {
  const { box } = useContext(PublicContext)

  return (
    <>
      {box && box.active &&
        <BoxSlotList />
      }
      {box && !box?.active &&
        <ErrorPage error="box_inactive" name={`${box.name} - ${box.zip_code}`} />
      }
    </>
  )
}
